/* MTL — Quick-Pick popup (finish swatches + full mockup gallery + add to cart)
 * --------------------------------------------------------------------------
 * Revives the custom Quick View popup that previously worked, but:
 *   • opened by the card's own "Select finish" button (no separate, overlapping button)
 *   • shows the FULL mockup gallery (big image + thumbnail strip)
 *   • required-finish gate with a red asterisk, mirroring the product page:
 *       no finish preselected → "Add to cart" is gated ("Choose your finish first")
 *       until the customer taps a finish, then it enables.
 *   • tapping a finish swaps the main image to that finish's on-neck lifestyle shot
 *   • product data is prefetched + cached so the popup opens instantly
 *
 * Eligibility: every non-personalized collection product that needs a variant
 * choice. Single-variant products submit directly; personalized SKUs continue
 * to the product page so required engraving is captured. Reversible: remove
 * this file + its <script> tag.
 */
(function () {
  'use strict';
  if (window.__mtlQuickPick) return; window.__mtlQuickPick = true;

  /* ---------- styling ---------- */
  function injectCSS() {
    if (document.getElementById('mtl-qp-css')) return;
    var s = document.createElement('style'); s.id = 'mtl-qp-css';
    s.textContent = [
      ".mtl-qp-overlay{position:fixed;inset:0;z-index:9999;display:none;align-items:center;justify-content:center;background:rgba(26,18,14,.55);-webkit-backdrop-filter:blur(3px);backdrop-filter:blur(3px);padding:16px;}",
      ".mtl-qp-overlay[data-visible='true']{display:flex;}",
      ".mtl-qp-modal{background:#fff;border-radius:14px;max-width:760px;width:100%;max-height:92vh;overflow-y:auto;position:relative;font-family:'Inter',-apple-system,sans-serif;box-shadow:0 24px 48px rgba(0,0,0,.26);}",
      ".mtl-qp-close{position:absolute;top:12px;right:12px;width:44px;height:44px;background:rgba(255,255,255,.95);border:1px solid rgba(0,0,0,.08);border-radius:50%;font-size:18px;line-height:1;cursor:pointer;z-index:3;display:flex;align-items:center;justify-content:center;}",
      ".mtl-qp-close:hover{background:#faf6f0;}",
      ".mtl-qp-body{display:grid;grid-template-columns:1fr;gap:0;}",
      "@media(min-width:640px){.mtl-qp-body{grid-template-columns:1.05fr 1fr;}}",
      ".mtl-qp-body>*{min-width:0;}",
      ".mtl-qp-gallery{background:#faf6f0;padding:14px;border-radius:14px 14px 0 0;}",
      "@media(min-width:640px){.mtl-qp-gallery{border-radius:14px 0 0 14px;}}",
      ".mtl-qp-main{width:100%;aspect-ratio:1/1;object-fit:cover;border-radius:10px;background:#f0eae2;display:block;}",
      ".mtl-qp-thumbs{display:flex;gap:8px;margin-top:10px;overflow-x:auto;padding-bottom:2px;-webkit-overflow-scrolling:touch;}",
      ".mtl-qp-thumb{flex:0 0 auto;width:54px;height:54px;border-radius:8px;overflow:hidden;border:2px solid transparent;background:#fff;padding:0;cursor:pointer;}",
      ".mtl-qp-thumb img{width:100%;height:100%;object-fit:cover;display:block;}",
      ".mtl-qp-thumb[data-active='true']{border-color:#765f00;}",
      ".mtl-qp-info{padding:22px;}",
      ".mtl-qp-eyebrow{font-size:10.5px;font-weight:700;letter-spacing:.16em;text-transform:uppercase;color:#765f00;margin:0 0 6px;}",
      ".mtl-qp-title{font-family:'Playfair Display','Cardo',Georgia,serif;font-size:21px;font-weight:500;color:#1a1a1a;margin:0 0 8px;line-height:1.3;}",
      ".mtl-qp-price{font-size:16px;font-weight:600;color:#1a1a1a;margin:0 0 14px;}",
      ".mtl-qp-finishes-label{font-size:11px;font-weight:600;letter-spacing:.08em;text-transform:uppercase;color:#6a6a6a;margin:16px 0 10px;}",
      ".mtl-qp-req{color:#c0392b;font-weight:700;margin-left:2px;}",
      ".mtl-qp-finishes-row{display:flex;gap:14px;flex-wrap:wrap;margin-bottom:16px;}",
      ".mtl-qp-swatch{display:flex;flex-direction:column;align-items:center;gap:6px;background:transparent;border:0;padding:4px 2px;cursor:pointer;min-width:60px;}",
      ".mtl-qp-circle{display:block;width:36px;height:36px;border-radius:50%;border:2px solid transparent;box-shadow:inset 0 2px 4px rgba(0,0,0,.18),0 1px 2px rgba(0,0,0,.10);transition:border-color .16s ease,transform .16s ease;}",
      ".mtl-qp-swatch[data-active='true'] .mtl-qp-circle{border-color:#765f00;transform:scale(1.06);}",
      ".mtl-qp-swatch:hover .mtl-qp-circle{border-color:rgba(184,150,12,.55);}",
      ".mtl-qp-gold .mtl-qp-circle{background:radial-gradient(circle at 30% 30%,#f4d68a 0%,#d4af37 45%,#a8810e 100%);}",
      ".mtl-qp-rose .mtl-qp-circle{background:radial-gradient(circle at 30% 30%,#f8d0c2 0%,#e8a596 45%,#b87d6e 100%);}",
      ".mtl-qp-stainless .mtl-qp-circle{background:radial-gradient(circle at 30% 30%,#f5f5f5 0%,#c0c0c0 45%,#8a8a8a 100%);}",
      ".mtl-qp-black .mtl-qp-circle{background:radial-gradient(circle at 30% 30%,#4a4a4a 0%,#1a1a1a 45%,#0a0a0a 100%);}",
      ".mtl-qp-swatch-label{font-size:11px;font-weight:500;color:#2c2c2c;text-align:center;}",
      ".mtl-qp-swatch[data-active='true'] .mtl-qp-swatch-label{color:#765f00;font-weight:600;}",
      ".mtl-qp-atc{background:#3d2b1f;color:#fff;border:none;padding:13px 20px;border-radius:6px;font-size:13.5px;font-weight:600;letter-spacing:.04em;text-transform:uppercase;cursor:pointer;width:100%;min-height:48px;box-shadow:0 2px 6px rgba(184,150,12,.25);}",
      ".mtl-qp-atc:hover{background:#2f2118;}",
      ".mtl-qp-atc[disabled]{background:#e7e2da;color:#5c5650;box-shadow:none;cursor:not-allowed;}",
      ".mtl-qp-link{display:block;text-align:center;margin-top:10px;color:#4a4a4a;font-size:12.5px;text-decoration:none;}",
      ".mtl-qp-link:hover{color:#765f00;text-decoration:underline;}",
      ".mtl-qp-trust{margin:10px 0 0;text-align:center;color:#59534b;font-size:12px;line-height:1.4;}",
      ".mtl-qp-loading{text-align:center;padding:48px;color:#6a6a6a;}"
    ].join("");
    document.head.appendChild(s);
  }

  /* ---------- helpers ---------- */
  function sized(url, w) {
    if (!url) return '';
    if (/[?&]width=/.test(url)) return url;
    return url + (url.indexOf('?') >= 0 ? '&' : '?') + 'width=' + w;
  }
  /* MTL 2026-10-18: strings come from locale keys (mtl_qp.*) rendered as JSON in layout/theme.liquid
     on non-English locales; English defaults below. Product data, links and cart calls use the
     market root (/en-ca/, /fr-ca/) so Canada sees CAD prices and French titles, like the PDP. */
  var I = {"dialog_label":"Select finish","close":"Close","loading":"Loading…","load_error":"Could not load.","view_product":"View product page",
    "finish":"Finish","choose_first":"Choose your finish first","add_to_cart":"Add to cart","adding":"Adding…","try_again":"Try again",
    "added":"✓ Added to cart","trust":"Free US & Canada shipping · Ships within 2 to 5 days","view_details":"View full details",
    "select_finish":"Select finish","jewelry":"Jewelry","gold":"Gold","rose_gold":"Rose Gold","black":"Black","stainless":"Stainless Steel"};
  try {
    var iel = document.getElementById('mtl-qp-i18n');
    if (iel) { var ij = JSON.parse(iel.textContent || '{}'); for (var ik in ij) { if (ij[ik]) I[ik] = ij[ik]; } }
  } catch (e) {}
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  function esc(v) { return String(v == null ? '' : v).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  function finishClass(title) {
    var t = (title || '').toLowerCase();
    if (/rose/.test(t)) return ['mtl-qp-rose', I.rose_gold];
    if (/gold|(^|[^a-z\u00e0-\u00ff])or([^a-z\u00e0-\u00ff]|$)/.test(t)) return ['mtl-qp-gold', I.gold];
    if (/black|noir/.test(t)) return ['mtl-qp-black', I.black];
    return ['mtl-qp-stainless', I.stainless];
  }
  function money(cents) {
    var s = '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var cur = window.Shopify && window.Shopify.currency && window.Shopify.currency.active;
    return (cur && cur !== 'USD') ? s + ' ' + cur : s;   /* same as the theme: money_with_currency | remove: ' USD' */
  }

  /* ---------- prefetch cache (lightning-fast open) ---------- */
  var DATA = {};        // handle -> product json (resolved)
  var INFLIGHT = {};    // handle -> promise
  function prefetch(handle) {
    if (!handle || DATA[handle] || INFLIGHT[handle]) return INFLIGHT[handle];
    INFLIGHT[handle] = fetch(ROOT + 'products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (p) { DATA[handle] = p; delete INFLIGHT[handle]; return p; })
      .catch(function () { delete INFLIGHT[handle]; return null; });
    return INFLIGHT[handle];
  }

  /* ---------- modal scaffold ---------- */
  var overlay = null;
  function ensureModal() {
    if (overlay) return overlay;
    overlay = document.createElement('div');
    overlay.className = 'mtl-qp-overlay';
    overlay.setAttribute('data-visible', 'false');
    overlay.innerHTML = '<div class="mtl-qp-modal" role="dialog" aria-modal="true" aria-label="' + esc(I.dialog_label) + '">' +
      '<button class="mtl-qp-close" aria-label="' + esc(I.close) + '">&times;</button>' +
      '<div class="mtl-qp-content"></div></div>';
    overlay.querySelector('.mtl-qp-close').addEventListener('click', close);
    overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    document.body.appendChild(overlay);
    return overlay;
  }
  /* MTL 2026-09-25: a product with a Size option (signet rings, Celestial Band) must never use this
     finish modal - it labelled sizes 6/7/8 as "Stainless Steel". Send the shopper to the product
     page instead, where the size guide is and a size must be chosen (assets/mtl-size-required.js). */
  function isSizeProduct(p) {
    var opts = (p && p.options) || [];
    for (var i = 0; i < opts.length; i++) {
      var n = typeof opts[i] === 'string' ? opts[i] : (opts[i] && opts[i].name);
      if (String(n || '').trim().toLowerCase() === 'size' && (p.variants || []).length > 1) return true;
    }
    return false;
  }
  function goToPdp(handle) { close(); window.location.href = ROOT + 'products/' + handle; }
  function open(handle) {
    if (DATA[handle] && isSizeProduct(DATA[handle])) { goToPdp(handle); return; }
    var o = ensureModal();
    o.setAttribute('data-visible', 'true');
    document.documentElement.style.overflow = 'hidden';
    if (DATA[handle]) { render(DATA[handle], handle); return; }      // instant from cache
    o.querySelector('.mtl-qp-content').innerHTML = '<p class="mtl-qp-loading">' + esc(I.loading) + '</p>';
    (INFLIGHT[handle] || prefetch(handle)).then(function (p) {
      if (!o.getAttribute('data-visible')) return;
      if (p && isSizeProduct(p)) { goToPdp(handle); return; }
      if (p) render(p, handle);
      else o.querySelector('.mtl-qp-content').innerHTML =
        '<p class="mtl-qp-loading">' + esc(I.load_error) + ' <a href="' + ROOT + 'products/' + handle + '">' + esc(I.view_product) + '</a></p>';
    });
  }
  function close() {
    if (!overlay) return;
    overlay.setAttribute('data-visible', 'false');
    document.documentElement.style.overflow = '';
  }

  /* ---------- render ---------- */
  function render(product, handle) {
    var content = overlay.querySelector('.mtl-qp-content');
    var media = (product.media && product.media.length)
      ? product.media.filter(function (m) { return m.media_type === 'image' || m.src; })
      : (product.images || []).map(function (s) { return { src: s, alt: product.title }; });
    var variants = (product.variants || []).filter(function (v) { return v.available; });
    if (!variants.length) variants = product.variants || [];

    // Default image = hero (NO finish preselected, mirroring the product page).
    var heroSrc = (media[0] && media[0].src) || product.featured_image;

    var thumbs = media.map(function (m) {
      return '<button type="button" class="mtl-qp-thumb" data-src="' + sized(m.src, 700) + '" data-active="' +
        (sized(m.src, 700) === sized(heroSrc, 700) ? 'true' : 'false') + '"><img loading="lazy" src="' +
        sized(m.src, 120) + '" alt="' + (m.alt || '') + '"></button>';
    }).join('');

    var swatches = variants.map(function (v) {
      var fc = finishClass(v.title);
      var img = (v.featured_image && v.featured_image.src) ? v.featured_image.src : '';
      return '<button type="button" class="mtl-qp-swatch ' + fc[0] + '" data-variant-id="' + v.id +
        '" data-variant-img="' + sized(img, 700) + '" data-price="' + v.price + '" data-active="false" aria-label="' +
        fc[1] + '"><span class="mtl-qp-circle" aria-hidden="true"></span><span class="mtl-qp-swatch-label">' +
        fc[1] + '</span></button>';
    }).join('');

    content.innerHTML =
      '<div class="mtl-qp-body">' +
        '<div class="mtl-qp-gallery">' +
          '<img class="mtl-qp-main" src="' + sized(heroSrc, 700) + '" alt="' + product.title + '">' +
          '<div class="mtl-qp-thumbs">' + thumbs + '</div>' +
        '</div>' +
        '<div class="mtl-qp-info">' +
          '<p class="mtl-qp-eyebrow">' + (product.type || I.jewelry) + '</p>' +
          '<h2 class="mtl-qp-title">' + product.title + '</h2>' +
          '<p class="mtl-qp-price">' + money(product.price) + '</p>' +
          '<p class="mtl-qp-finishes-label">' + esc(I.finish) + '<span class="mtl-qp-req" aria-hidden="true">*</span></p>' +
          '<div class="mtl-qp-finishes-row">' + swatches + '</div>' +
          '<button type="button" class="mtl-qp-atc" data-variant-id="" disabled>' + esc(I.choose_first) + '</button>' +
          '<p class="mtl-qp-trust">' + esc(I.trust) + '</p>' +
          '<a class="mtl-qp-link" href="' + ROOT + 'products/' + handle + '">' + esc(I.view_details) + ' &rarr;</a>' +
        '</div>' +
      '</div>';

    var mainImg = content.querySelector('.mtl-qp-main');
    var atc = content.querySelector('.mtl-qp-atc');

    content.querySelectorAll('.mtl-qp-thumb').forEach(function (t) {
      t.addEventListener('click', function () {
        mainImg.src = t.dataset.src;
        content.querySelectorAll('.mtl-qp-thumb').forEach(function (x) { x.dataset.active = 'false'; });
        t.dataset.active = 'true';
      });
    });

    content.querySelectorAll('.mtl-qp-swatch').forEach(function (sw) {
      sw.addEventListener('click', function () {
        content.querySelectorAll('.mtl-qp-swatch').forEach(function (x) { x.dataset.active = 'false'; });
        sw.dataset.active = 'true';
        // Release the required-finish gate
        atc.dataset.variantId = sw.dataset.variantId;
        atc.disabled = false;
        atc.textContent = I.add_to_cart + ' — ' + money(parseInt(sw.dataset.price, 10));
        // Swap to this finish's on-neck lifestyle image (like the product page)
        if (sw.dataset.variantImg) {
          mainImg.src = sw.dataset.variantImg;
          content.querySelectorAll('.mtl-qp-thumb').forEach(function (x) {
            x.dataset.active = (x.dataset.src === sw.dataset.variantImg) ? 'true' : 'false';
          });
        }
      });
    });

    atc.addEventListener('click', function () {
      if (atc.disabled) return;
      var id = parseInt(atc.dataset.variantId, 10);
      if (!id) return;
      atc.disabled = true; atc.textContent = I.adding;
      fetch(ROOT + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
      }).then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return fetch(ROOT + 'cart.js');
      }).then(function (r) { return r.json(); }).then(function (cart) {
        updateBubble(cart.item_count);
        showAdded(cart);
      }).catch(function () {
        atc.disabled = false; atc.textContent = I.try_again;
      });
    });
  }

  function showAdded(cart) {
    var content = overlay.querySelector('.mtl-qp-content');
    var info = content.querySelector('.mtl-qp-info');
    if (!info) return;
    var atc = info.querySelector('.mtl-qp-atc');
    if (atc) {
      atc.textContent = I.added;
      atc.disabled = true;
      atc.setAttribute('aria-live', 'polite');
    }

    document.dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true,
      detail: {
        resource: cart,
        sourceId: 'mtl-quickpick',
        data: { source: 'mtl-quickpick', itemCount: cart.item_count }
      }
    }));

    setTimeout(function () {
      close();
      var drawer = document.querySelector('cart-drawer-component');
      if (drawer && typeof drawer.open === 'function') drawer.open();
    }, 700);
  }

  function updateBubble(count) {
    document.querySelectorAll('.cart-bubble__text-count, [data-cart-count], .cart-count, .header-actions__cart-count')
      .forEach(function (el) { el.textContent = count; });
    document.querySelectorAll('cart-icon, .header-actions__cart-icon').forEach(function (el) {
      el.classList.add('header-actions__cart-icon--has-cart');
    });
  }

  /* ---------- trigger: hook the card's own button + prefetch ---------- */
  function handleFor(qa) {
    var card = qa.closest('product-card') || qa.closest('.product-card');
    var mode = qa.getAttribute('data-mtl-purchase-mode') || '';
    var legacyFinishCard = card && card.getAttribute('data-mtl-qv-eligible') === 'true';

    /* Every non-personalized product that needs a choice stays in the
       collection and uses Quick-Pick. Direct products use native form submit;
       personalized products are handled by the dedicated PDP router. */
    var eligible = mode === 'finish' || mode === 'options' || (!mode && legacyFinishCard);
    var link = card && card.querySelector('a[href*="/products/"]');
    var handle = link ? (link.getAttribute('href') || '').split('/products/').pop().split('?')[0].split('#')[0] : '';
    return { card: card, eligible: eligible, link: link, handle: handle, mode: mode };
  }

  function wire(qa) {
    if (qa.__mtlqp) return;

    var info = handleFor(qa);
    if (!info.eligible) return;
    qa.__mtlqp = true;

    /* Prefetch product data on hover/pointerdown so the selector opens on the
       first tap without navigation or an empty intermediate modal. */
    if (info.handle && info.card) {
      var warm = function () { prefetch(info.handle); };
      info.card.addEventListener('pointerenter', warm, { once: true, passive: true });
      info.card.addEventListener('pointerdown', warm, { once: true, passive: true });
    }

    qa.handleClick = function (event) {
      try {
        if (event && event.preventDefault) event.preventDefault();
        if (event && event.stopPropagation) event.stopPropagation();
      } catch (e) {}

      var current = handleFor(qa);
      if (current.eligible && current.handle) open(current.handle);
    };
  }
  function scan() {
    document.querySelectorAll('product-card quick-add-component, .product-card quick-add-component').forEach(wire);
    // Relabel the card button to "Select finish" on eligible cards.
    document.querySelectorAll('product-card[data-mtl-qv-eligible="true"] .quick-add__button--choose .add-to-cart-text__content span span, .product-card[data-mtl-qv-eligible="true"] .quick-add__button--choose .add-to-cart-text__content span span')
      .forEach(function (el) {
        var qa = el.closest('quick-add-component'); var m = qa && qa.getAttribute('data-mtl-purchase-mode');
        if (m && m !== 'finish') return;   // size products carry their own honest label ("Select size")
        if (el && el.textContent.trim() && el.textContent.trim().toLowerCase() !== I.select_finish.toLowerCase()) el.textContent = I.select_finish; });
  }

  function init() {
    injectCSS();
    scan();
    if (window.MutationObserver && document.body) {
      var pending = false;
      new MutationObserver(function () {
        if (pending) return; pending = true;
        requestAnimationFrame(function () { pending = false; scan(); });
      }).observe(document.body, { childList: true, subtree: true });
    }
    // Warm first-screen eligible cards.
    if (window.IntersectionObserver) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          var card = en.target;
          var link = card.querySelector('a[href*="/products/"]');
          if (link) prefetch((link.getAttribute('href') || '').split('/products/').pop().split('?')[0].split('#')[0]);
          io.unobserve(card);
        });
      }, { rootMargin: '200px' });
      document.querySelectorAll(
        'quick-add-component[data-mtl-purchase-mode="finish"], quick-add-component[data-mtl-purchase-mode="options"]'
      ).forEach(function (qa) {
        var card = qa.closest('product-card') || qa.closest('.product-card');
        if (card) io.observe(card);
      });
      document.querySelectorAll('product-card[data-mtl-qv-eligible="true"]').forEach(function (card) {
        if (!card.querySelector('quick-add-component[data-mtl-purchase-mode]')) io.observe(card);
      });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', scan);
})();
